export const ADMIN_SET_USERS = 'ADMIN_SET_USERS';
export const ADMIN_EDIT_TIMELINE = 'ADMIN_EDIT_TIMELINE';
export const ADMIN_REMOVE_TIMELINE = 'ADMIN_REMOVE_TIMELINE';
export const ADMIN_REMOVE_USER_FROM_COMPANY = 'ADMIN_REMOVE_USER_FROM_COMPANY';
export const ADMIN_SET_NEW_ADMIN = 'ADMIN_SET_NEW_ADMIN';
export const ADMIN_REMOVE_USER_FROM_PROJECT = 'ADMIN_REMOVE_USER_FROM_PROJECT';
export const ADMIN_ADD_USER_TO_PROJECT = 'ADMIN_ADD_USER_TO_PROJECT';
export const EDIT_PROJECT = 'EDIT_PROJECT';